export const SPACING_A = {
  extraSmall: { size: 20 },
  small: { size: 20 },
  medium: { size: 28 },
  large: { size: 28 },
  extraLarge: { size: 28 }
};

export const SPACING_B = {
  extraSmall: { size: 16 },
  small: { size: 14 },
  medium: { size: 20 },
  large: { size: 20 },
  extraLarge: { size: 20 }
};

export const SPACING_C = {
  extraSmall: { size: 14 },
  small: { size: 14 },
  medium: { size: 14 },
  large: { size: 14 },
  extraLarge: { size: 14 }
};

export const BUTTON_SQUARE_SIZE = {
  extraSmall: { width: 16 },
  small: { width: 24 },
  medium: { width: 36 },
  'large+extraLarge': { width: 44 }
};

export const LABEL_TEXT_FONT_SIZE = {
  extraSmall: { fontSize: 12 },
  small: { fontSize: 12 },
  medium: { fontSize: 14 },
  large: { fontSize: 16 },
  extraLarge: { fontSize: 18 }
};

export const ROWITEM_SUBLABEL_ICON = { marginLeft: 8 };
